'use client'
import { cn } from '../../helpers/utils.js'
import type { Img } from '../../types/props.js'
import { withLayout } from '../../shared/Styles.js'
import { Grid, GridItem } from '../../components/grid.js'
import { Picture, Text } from '../../components/index.js'
export type GraphicMoreDataType = {
  img: Img
  mobileImg: Img
  title: string
  description: string
  theme: 'light' | 'dark'
  fullWidth: 'true' | 'false'
  span: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
}
interface GraphicMoreType extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    shape?: 'rounded' | 'square'
    productsTab: GraphicMoreDataType[]
  }
}

const GraphicMore = ({ data, className, ...rest }: GraphicMoreType) => {
  const { productsTab, shape } = data

  return (
    <div {...rest} className={cn(className)}>
      <div
        className={cn('creativeModuleBlock', 'tablet:block box-border hidden w-full overflow-hidden text-[#080A0F]')}
      >
        <Grid className={cn('laptop:gap-4 grid grid-cols-12 gap-3 ', className)}>
          {productsTab?.map((item, index) => {
            return (
              <GridItem
                key={index}
                span={item.span}
                className={cn(
                  'text-info-primary relative w-full overflow-hidden',
                  shape === 'rounded' ? 'rounded-2xl' : 'rounded-none',
                  '',
                  {
                    'aiui-dark': item?.theme === 'dark',
                  }
                )}
              >
                <Picture source={item?.img?.url} className="size-full" imgClassName="" />
                <div className="footBottom desktop:p-6 lg-desktop:p-8 absolute inset-0 z-10 overflow-hidden p-4">
                  {item?.title && (
                    <Text
                      html={item?.title}
                      as="p"
                      className="desktop:text-2xl line-clamp-2 text-xl font-bold leading-[1.2]"
                    />
                  )}
                  {item?.description && (
                    <Text
                      html={item?.description}
                      className="desktop:text-base lg-desktop:text-lg mt-1 line-clamp-2 text-sm font-bold"
                    />
                  )}
                </div>
              </GridItem>
            )
          })}
        </Grid>
      </div>
      <div className="tablet:hidden block text-[#080A0F]">
        <div className=" flex flex-wrap gap-[12px]">
          {productsTab?.map((it, ind) => {
            return (
              <div
                key={ind}
                className={cn(
                  'text-info-primary relative overflow-hidden',
                  shape === 'rounded' ? 'rounded-xl' : 'rounded-none',
                  { 'aiui-dark': it?.theme === 'dark' },
                  it?.fullWidth === 'true'
                    ? 'w-full flex-none' // 占满整行
                    : ' w-[calc(50%-6px)]' // 普通元素
                )}
              >
                <Picture source={it?.mobileImg?.url} className="size-full" imgClassName="h-full object-cover" />
                <div className="footBottomMob desktop:p-6 lg-desktop:p-8 absolute inset-0 z-10 overflow-hidden p-4">
                  {it?.title && (
                    <Text html={it?.title} as="p" className="lg-desktop:text-2xl text-xl font-bold leading-[1.2]" />
                  )}
                  {it?.description && (
                    <Text
                      html={it?.description}
                      className="desktop:text-base lg-desktop:text-lg mt-1 line-clamp-2 text-sm font-bold leading-[1.4]"
                    />
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default withLayout(GraphicMore)
